import React, { useState } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import FeedBack from "./Pages/FeedBack/FeedBack";
import { LANCONTEXT } from "./Pages/Context/LanContext";
import Success from "./Components/Success";
import Login from "./Components/Login";
import Home from "./Components/Home";
import MainHeading from "./Pages/studentOpRegestration/MainHeading";
import StudentDetails_1 from "./Pages/studentOpRegestration/StudentDetails_1.jsx";

function App() {
  const [lan, upLan] = useState(true);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/home",
      element: <Home />,
    },
    {
      path: "/feedback",
      element: <FeedBack />,
    },
    {
      path: "/success",
      element: <Success />,
    },
    {
      path: "/student/op/registration",
      element: <MainHeading />,
    },
    {
      path: "/test/student/op/registration",
      element: <StudentDetails_1 />,
    },
  ]);

  return (
    <div className="App">
      <LANCONTEXT.Provider value={{ lan, upLan }}>
        <RouterProvider router={router} />
      </LANCONTEXT.Provider>
    </div>
  );
}

export default App;
